import { ImportOptionsWebComponent } from './component/ImportOptionsWebComponent';
import { WEB_COMPONENT_MDR_CONTACT_IMPORT_OPTIONS } from '../../../../webcomponents.constants';

export { ImportOptionsWebComponent };

window.customElements.define(WEB_COMPONENT_MDR_CONTACT_IMPORT_OPTIONS, ImportOptionsWebComponent);
